/**
 * @file Static.js.
 * @author Sérgio Ferraz Souza <todentro@gmail.com>
 * @copyright Cognatis GeoAnalytics & Big Data Ltda :: 2021
 */

import Service from './Service'
import Request from '../components/http/request'

const defaultJsonHeaders = {
  headers: {
    'Content-Type': 'application/json'
  }
}

class Static extends Service {
  constructor (options, resource) {
    super(options)
    this.resource = resource
    this.request = new Request({tag: 'static'})
    // this.request = new Request({environment: 'local', tag: 'static'})
  }
  /**
   * Get file configuration
   *
   * @async
   * @function get
   * @return {Promise<json>} File configuration object
   */
  async get (guid) {
    return new Promise((resolve, reject) => {
      if (typeof guid === 'undefined') reject(new Error('Esperado o identificador do arquivo'))
      const endPoint = `/api/0.1-a/filemanager?gdIdEvents=${guid}`
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
  /**
   * Get all upload files
   *
   * @async
   * @function getAll
   * @return {Promise<json>} The json with the uploads
   */
  async getAll () {
    return new Promise((resolve, reject) => {
      const endPoint = '/api/0.1-a/filemanager'
      this.request.get(endPoint, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
  /**
   * Read file configuration
   *
   * @async
   * @function read
   * @return {Promise<json>} Array of the file configuration
   */
  async read (guid, data) {
    return new Promise((resolve, reject) => {
      if (typeof guid === 'undefined') reject(new Error('Esperado o identificador do arquivo'))
      const endPoint = `/api/0.1-a/filemanager/read/${guid}`
      this.request.post(endPoint, data, defaultJsonHeaders)
        .then(response => resolve(response))
        .catch(() => reject)
    })
  }
}

export { Static }
